import { HttpClient, URL_API } from "../../network";


class AuditLogServiceApi extends HttpClient {
  getList = async (
    params: TParams & {
      by_type?: string;
    },
  ) => {
    const data = await this.instance.get(URL_API.AUDIT_LOG.GET_LIST, {
      params,
    });
    return data;
  };

  getListByType = async (
    params: TParams & {
      type?: string;
      action?: string;
      id?: string;
    },
  ) => {
    const { id, ...restParams } = params;
    const url = `${URL_API.AUDIT_LOG.GET_LIST_BY_TYPE}/${id}`;
    const data = await this.instance.get(url, {
      params: restParams,
    });
    return data;
  };
}
export const AuditLogService = new AuditLogServiceApi();
